import Mmenu from "mmenu-js";
import "mmenu-js/dist/mmenu.css";

// Tworzenie SVG strzałki
const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
svg.setAttribute("width", "17");
svg.setAttribute("height", "11");
svg.setAttribute("viewBox", "0 0 17 11");
svg.setAttribute("fill", "none");

const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
path.setAttribute("d", "M16 9.81934L8.36161 2.18094L0.723215 9.81934");
path.setAttribute("stroke", "#181718");
path.setAttribute("stroke-width", "2.01786");
path.setAttribute("fill", "none");

svg.appendChild(path);

// Tworzenie przycisku
const button = document.createElement("button");
button.classList.add("submenu-button", "ms-auto");
button.appendChild(svg);

document.addEventListener("DOMContentLoaded", () => {
  // Dodanie klasy dla submenu > 6 elementów
  const desktopSubMenu = document.querySelectorAll(".mega-menu .sub-menu");
  desktopSubMenu.forEach((submenu) => {
    const listItems = submenu.querySelectorAll("li");
    if (listItems.length > 6) submenu.classList.add("sub-menu-large");
  });

  // Inicjalizacja mmenu
  const menu = new Mmenu("#menu", {
    extensions: ["theme-light", "fullscreen"],
    offCanvas: { position: "top", zposition: "front", container: "#page" },
    navbars: { content: ["prev", "close"] },
  });

  const hamburger = document.querySelector('#header a[href="#menu"]');
  if (hamburger) {
    hamburger.addEventListener("click", (e) => {
      e.preventDefault();
      menu.open();
    });
  }

  // Dodanie koszyka do menu
  const menuFooter = document.createElement("ul");
  menuFooter.classList.add("menu-footer");
  const menuContainer = document.querySelector(".mm-menu");
  const basket = document.querySelector(".xoo-wsc-menu-item");
  if (basket) menuFooter.appendChild(basket.cloneNode(true));
  if (menuContainer) menuContainer.appendChild(menuFooter);

  // Obsługa submenu
  const menuItemsWithSubmenu = document.querySelectorAll(
    ".mm-listview .menu-item-has-children"
  );

  menuItemsWithSubmenu.forEach((item) => {
    const clonedButton = button.cloneNode(true);
    const link = item.querySelector("a");
    link.after(clonedButton);

    const toggleSubmenu = (event) => {
      event.preventDefault(); // zapobiega przeładowaniu strony

      const currentSubmenu = document.querySelector(".sub-menu.d-block");
      const currentButton = document.querySelector(".rotate");

      // Zamknij inne otwarte submenu
      if (
        currentSubmenu &&
        currentSubmenu !== item.querySelector(".sub-menu")
      ) {
        currentSubmenu.classList.remove("d-block");
        if (currentButton) currentButton.classList.remove("rotate");
      }

      // Toggle bieżącego submenu
      const submenu = item.querySelector(".sub-menu");
      if (!submenu.classList.contains("d-block")) {
        submenu.classList.add("d-block");
        clonedButton.classList.add("rotate");
      } else {
        submenu.classList.remove("d-block");
        clonedButton.classList.remove("rotate");
      }
    };

    // Kliknięcie tylko w <a> lub button rozwija submenu
    link.addEventListener("click", toggleSubmenu);
    clonedButton.addEventListener("click", toggleSubmenu);

    // Usuń kliknięcie całego <li>
    item.addEventListener("click", (e) => {
      e.stopPropagation(); // zapobiega przypadkowemu rozwinięciu przez li
    });
  });
});
